 /* This file was generated by a tool. Modifying it will produce unexpected behavior. */
/* tslint:disable */

const strings = UNIT_TEST
                 ? require('resx-strings/en-us.json')
                 : require('resx-strings');
export interface IStrings {
  platformOrApplicationFailedToLoadError: string;
  applicationFailedToInitializeError: string;
  applicationFailedToLoadError: string;
  invalidManifestError: string;
  invaliPreloadedDataError: string;
  manifestNotFoundError: string;
  debugManifestLoadingWarning: string;
}

export default (strings['_D2Ups1G4nZEu0oTY7FfRsA'] || {}) as IStrings;



// WEBPACK FOOTER //
// /src/SPModuleLoader.resx.ts


// WEBPACK FOOTER //
// webpack:///src/SPModuleLoader.resx.ts